module.exports = __webpack_public_path__ + "static/media/video-worry-time-es.b5bfb6c0.vtt";